import React, { useEffect, useState } from 'react';
import { GoogleMap, Marker, StandaloneSearchBox, useLoadScript } from '@react-google-maps/api';
import { googleApiKey } from '../../services/CommonUrl';
import { Modal } from 'react-bootstrap';
const containerStyle = {
  width: '100%',
  height: '500px',
};

const AddressSelector = ({ onSelectAddress, showModal, setShowModal, addressData, destination }) => {
  const [map, setMap] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [center, setCenter] = useState({ lat: -34.397, lng: 150.644 });

  const handleMapLoad = (map) => {
    setMap(map);
    const input = document.getElementById('search-input');
    const searchBox = new window.google.maps.places.SearchBox(input);
    map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);
    if (addressData) {
      const { formatted_address, lat, lng } = addressData;
      input.value = formatted_address || "";
      setSelectedAddress(addressData);
      map.setCenter({ lat: lat, lng: lng });
    }

    searchBox.addListener('places_changed', () => {
      const places = searchBox.getPlaces();
      if (!places || places.length === 0) return
      const place = places[0];
      const address = place.formatted_address;
      const lat = place?.geometry?.location?.lat();
      const lng = place?.geometry?.location?.lng();
      // console.log("places_changed", address, lat, lng)

      if (lat && lng) {
        setSelectedAddress({ ...selectedAddress, address: address, lat: lat, lng: lng });
        onSelectAddress({ address, lat, lng });
        input.value = address;
        map.setCenter(place.geometry.location);
        map.setZoom(18);
      }
      setShowModal(false);
    });
  };
  const handleMapClick = (event) => {
    const { latLng } = event;
    const lat = latLng.lat();
    const lng = latLng.lng();
    const geocoder = new window.google.maps.Geocoder();
    window.google.maps.event.addListener(map, 'resize', function () {
      console.log("resize triggered");
      // setCenter({ lat, lng });
    });

    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const address = results[1].formatted_address;
        setSelectedAddress({ ...selectedAddress, address, lat, lng });
        onSelectAddress({ address, lat, lng });
        document.getElementById('search-input').value = address;
      } else {
        console.error('Geocoder failed due to:', status);
      }
    });
    setShowModal(false);
  };

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: `${googleApiKey}`,
    libraries: ['places']
  });

  useEffect(() => {
    if (destination?.lat && destination?.lng) {
      setCenter({ lat: destination?.lat, lng: destination?.lng });
    }
  }, [destination]);

  // console.log(addressData, destination)

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      keyboard={false}
      // fullscreen={true}
      size="lg"
      className="add-travellers-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Select Location
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='p-0'>
        {isLoaded ? (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={10}
            onLoad={handleMapLoad}
            onClick={handleMapClick}
          >
            {selectedAddress && <Marker position={selectedAddress} />}

            {/* Search Box */}
            <StandaloneSearchBox>
              <input
                id="search-input"
                type="text"
                placeholder="Search for an address"
                style={{
                  boxSizing: 'border-box',
                  border: '0',
                  width: 'calc(100% - 264px)',
                  height: '40px',
                  padding: '4px 12px',
                  borderRadius: '3px',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
                  fontSize: '14px',
                  outline: 'none',
                  textOverflow: 'ellipses',
                  marginLeft: '10px',
                  marginTop: '11px'
                }}
              />

            </StandaloneSearchBox>
          </GoogleMap>
        ) : null}
      </Modal.Body>
    </Modal>
  )
};

export default AddressSelector;